
import { mapState, mapGetters, mapActions } from 'vuex';
import ReviewContentType from '@/enums/ReviewContentType';

export default {
  name: 'AppParentReviewSectionListV3',
  props: {
    reviews: { type: Array, default: () => [] },
    popupParams: { type: Object, required: true }
  },
  data() {
    return {
      collapsed: false
    };
  },
  computed: {
    ...mapState('widget', ['widget', 'isMobile']),
    ...mapGetters('review', ['showDate']),
    collapsible() {
      return this.reviews.length >= 2;
    },
    collapsedSteps() {
      if (this.reviews.length < 2) return null;

      return Array.from(
        { length: this.reviews.length - 1 },
        (_, i) => `${i + 2}차`
      ).join(', ');
    },
    displayedReviews() {
      return this.collapsed
        ? [this.reviews[this.reviews.length - 1]]
        : this.reviews;
    }
  },
  created() {
    this.collapsed = this.collapsible;
  },
  methods: {
    ...mapActions('widget', ['clickMoreReviews']),
    displayMediaSection(review) {
      return (
        review.content_type !== ReviewContentType.RESTRICTED &&
        review.media_count > 0
      );
    },
    clickToggle() {
      this.collapsed = !this.collapsed;
      if (!this.collapsed) {
        this.clickMoreReviews({ id: this.widget.id });
      }
    }
  }
};
